export const replaceGqlError = (message) => message.replace('GraphQL error:', '')
